import { SubscriptionAddon } from '@/types/Subscription';

type SubscriptionAddonCode = Exclude<SubscriptionAddon['code'], 'basket-v2'>;

/**
 * Returns the requested add-on from the provided list of the subscription add-ons.
 *
 * There are 2 types of basket add-ons in HOK: "Basket" and "Basket 2.0" and
 * ONLY ONE of them is enabled per region. "Basket 2.0" is created to introduce
 * the new prices. So the new members would pay the new price
 * and the old ones would remain on the old price.
 *
 */
export const getSubscriptionAddon = (
  code: SubscriptionAddonCode,
  list?: SubscriptionAddon[]
) => {
  if (!list) return;
  if (code === 'basket') {
    return list?.find(
      addon => addon.code === 'basket' || addon.code === 'basket-v2'
    );
  }

  return list?.find(addon => addon.code === code);
};
